import { createFeatureSelector, createReducer, createSelector, on } from "@ngrx/store";
import * as bookAction from "./book.actions";
import { Book, IBookResponse, UserBook } from "../../models/book";


export interface IBookState {
    books: { [bookId: string]: UserBook }
}

export const initialState: IBookState = {
    books: {}
}

export const bookReducer = createReducer<IBookState>(
    initialState,
    on(bookAction.FetchBookInfoSuccessAction, (state: IBookState, props: { response: IBookResponse }) => {
        return {
            ...state,
            books: {
                ...state.books,
                [props.response.Value.bookId]: props.response.Value
            }
        }
    }),
);

const selectBookState = createFeatureSelector<IBookState>("books");

export const selectBookById = (bookId: string) =>
    createSelector(selectBookState, (state: IBookState | undefined) =>
        state && state.books ? state.books[bookId] ?? null : null
    );
